import {GuidesEnum, PlanTypeEnum} from 'presentation/constants';

import {useTheme} from '@mui/material';

import {useLocationStore} from 'presentation/pages/private/store/locationStore';
import {FlowType} from 'presentation/pages/private/store/locationStore/constants';
import {getUserInfoFromToken} from 'presentation/utils';
import {useNavigate} from 'react-router-dom';
import {useGuideQueryParams} from 'presentation/modules/guide/shared/hooks/useGuideQueryParams';
import {useGuideStore} from 'presentation/modules/guide/shared/store/guideStore';

export function useCurrentLocation(type?: PlanTypeEnum) {
	const {palette} = useTheme();
	const navigate = useNavigate();
	const {deleteAllQueryParams} = useGuideQueryParams();

	const cdPessoaC = getUserInfoFromToken().cdPessoa;

	const getLocation = useLocationStore(state => state.getLocation);
	const selectedLocation = getLocation(
		cdPessoaC,
		type === PlanTypeEnum.HEALTH ? FlowType.HEALTH_GUIDE : FlowType.ODONTO_GUIDE,
	);
	const coordinates = useGuideStore(state => state.coordinates);
	const setCoordinates = useGuideStore(state => state.setCoordinates);
	const resetHealthStates = useGuideStore(state => state.resetHealthStates);
	const resetOdontoStates = useGuideStore(state => state.resetOdontoStates);

	const {cdUf} = selectedLocation.state;
	const cityName = selectedLocation.city;

	const handleGoToUfSelection = () => {
		deleteAllQueryParams();
		if (type === PlanTypeEnum.ODONTO) {
			resetOdontoStates();
		}

		if (type !== PlanTypeEnum.ODONTO) {
			resetHealthStates();
		}

		if (coordinates) {
			navigate(
				type === PlanTypeEnum.ODONTO
					? GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_UF
					: GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_UF,
			);
			setCoordinates(null);
		}
	};

	return {
		palette,
		cdPessoaC,
		selectedLocation,
		coordinates,
		cdUf,
		cityName,
		handleGoToUfSelection,
	};
}
